import { Form } from 'antd';
import BaseModal from 'basic-ui-lib/components/Modal/BaseModal';
import { forwardRef, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import { setPageLoading } from 'widgets/PageLoading';
import mediaApis from 'modules/media/services/apis';
import { toast } from 'react-toastify';
import useGetManageLibrary from 'modules/media/services/hooks/useGetManageLibrary';
import { getMessageError } from 'services/response';
import InputLarge from 'basic-ui-lib/components/Input/InputLarge';
import { useMediaQuery } from 'react-responsive';
import BaseInput from 'basic-ui-lib/components/Input/BaseInput';
import { Colors } from 'basic-ui-lib';

export interface CreateFolderModalRef {
  open: (currentPath: string) => void;
}
interface Props {}

interface FormValues {
  name: string;
}

const CreateFolderModal = forwardRef<CreateFolderModalRef, Props>(({}, ref) => {
  const [form] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState('');
  const [, mutate] = useGetManageLibrary(true);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  useImperativeHandle(ref, () => ({
    open: (currentPath: string) => {
      setCurrentPath(currentPath);
      setIsOpen(true);
    },
  }));

  const onClose = () => {
    setIsOpen(false);
    form.resetFields();
  };

  const handleSubmit = () => {
    form.submit();
  };

  const handleFinish = async (values: FormValues) => {
    try {
      setPageLoading(true);

      const res = await mediaApis.createMediaFolder(values.name, currentPath);

      if (res?.data?.data) {
        toast.success('Create folder successful');
        mutate(currentPath);
        onClose();
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Create folder failed');
    } finally {
      setPageLoading(false);
    }
  };

  if (isMobile) {
    return (
      <BaseModal
        title='New Folder'
        isOpen={isOpen}
        width={'100%'}
        onClose={onClose}
        okText='OK'
        onOk={handleSubmit}
        isMobile
      >
        <Container>
          <Form layout='vertical' form={form} onFinish={handleFinish}>
            <Form.Item name='name' rules={[{ required: true, message: 'Please input folder name' }]}>
              <BaseInput placeholder='Please enter folder name' />
            </Form.Item>
          </Form>
        </Container>
      </BaseModal>
    );
  }

  return (
    <BaseModal
      title='Create Folder'
      isOpen={isOpen}
      width={1000}
      onClose={onClose}
      okText='OK'
      onOk={handleSubmit}
    >
      <Container>
        <Form layout='vertical' form={form} onFinish={handleFinish}>
          <Form.Item name='name' rules={[{ required: true, message: 'Please input folder name' }]}>
            <InputLarge placeholder='Please enter folder name' />
          </Form.Item>
        </Form>
      </Container>
    </BaseModal>
  );
});

CreateFolderModal.displayName = 'CreateFolderModal';
export default CreateFolderModal;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 0 50px;

  @media (max-width: 768px) {
    padding: 16px 16px 32px;
    background: ${Colors.neutral.bg[2]};

    .ant-form-item {
      margin-bottom: 0px;
    }
  }


`;
